import { FromSchema } from '@40seas/entities/common';
import { z } from 'zod';

export const RutterPlatformDataSchema = z.object({
    accessToken: z.string().optional(),
    storeUniqueName: z.string().optional(),
    updateUrl: z.string().optional(),
    paymentsAccountId: z.string().optional(),
    vendorId: z.string().optional(),
    feesAccountId: z.string().optional(),
});

export class RutterPlatformData extends FromSchema(RutterPlatformDataSchema) {
    accessToken?: string;
    storeUniqueName?: string;
    updateUrl?: string;
    paymentsAccountId?: string;
    vendorId?: string;
    feesAccountId?: string;
}
